import { Notify } from '@swpsoftware/commons-vue';
import { getErrorMessage } from '@/services/ErrorMessageProvider';

export function showErrorNotification(error: unknown) {
  const errorMessage = getErrorMessage(error);
  if (errorMessage) {
    Notify.error(errorMessage);
  } else {
    throw error;
  }
}
